import { useEffect, useState } from 'react';
import { getPublicPlanCatalog, PublicPlanCatalog } from './SaasApi';

type PublicPlanCatalogState = {
    catalog: PublicPlanCatalog | null;
    isLoading: boolean;
    error: string | null;
    reload: () => void;
};

// Keep catalogue loading consistent across the public plans and signup routes.
export const usePublicPlanCatalog = (): PublicPlanCatalogState => {
    const [catalog, setCatalog] = useState<PublicPlanCatalog | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [requestNumber, setRequestNumber] = useState(0);

    useEffect(() => {
        let active = true;
        setIsLoading(true);
        setError(null);

        getPublicPlanCatalog()
            .then((result) => {
                if (active) setCatalog(result);
            })
            .catch((catalogError: unknown) => {
                if (active) {
                    setCatalog(null);
                    setError(catalogError instanceof Error
                        ? catalogError.message
                        : 'Plans are temporarily unavailable.');
                }
            })
            .finally(() => {
                if (active) setIsLoading(false);
            });

        return () => { active = false; };
    }, [requestNumber]);

    return {
        catalog,
        isLoading,
        error,
        reload: () => setRequestNumber((current) => current + 1),
    };
};
